import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './permission'
import ElementPlus from 'element-plus'
import 'echarts'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css"
import TailUi from '@/components/Tail-ui/index'  //组件库
const app = createApp(App)

import * as ElIconsModules from '@element-plus/icons-vue'
app.use(TailUi)

// 全局注册element-plus icon图标组件
Object.keys(ElIconsModules).forEach((key) => {//循环遍历组件名称
    if ("Menu" !== key) {//如果不是图标组件不是Menu，就跳过，否则加上ICon的后缀
        app.component(key, ElIconsModules[key]);
    } else {
        app.component(key + "Icon", ElIconsModules[key]);
    }
});

import '@/styles/index.scss' // global css
app.use(store).use(router).use(ElementPlus,{locale:zhCn}).component("QuillEditor",QuillEditor).mount('#app')
